import React from 'react';
import { Box } from '@mui/material';
import GameRules from './GameRules';
import LanguageSelector from './LanguageSelector';
import ThemeToggle from './ThemeToggle';

function TopActionBar({ children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        flexWrap: 'nowrap',
        overflowX: 'auto',
        mb: { xs: 2, sm: 3 },
        px: 1,
        py: 0.5
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'nowrap', flexShrink: 0 }}>
        <GameRules />
        {children}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'nowrap', flexShrink: 0 }}>
        <ThemeToggle />
        <LanguageSelector />
      </Box>
    </Box>
  );
}

export default TopActionBar;
